import {
    Vector2
} from 'three';
import {
    EffectComposer
} from 'three/examples/jsm/postprocessing/EffectComposer.js';
import {
    RenderPass
} from 'three/examples/jsm/postprocessing/RenderPass.js';
import {
    ShaderPass
} from 'three/examples/jsm/postprocessing/ShaderPass.js';
import {
    CopyShader
} from 'three/examples/jsm/shaders/CopyShader.js';
import {
    OutlinePass
} from 'three/examples/jsm/postprocessing/OutlinePass.js';
import {
    FXAAShader
} from 'three/examples/jsm/shaders/FXAAShader.js';

let composer, renderPass, copyPass, outlinePass, fxaaShader

export function init(renderer, scene, camera) {

    const size = renderer.getDrawingBufferSize(new Vector2());

    composer = new EffectComposer(renderer);

    renderPass = new RenderPass(scene, camera);
    composer.addPass(renderPass);

    copyPass = new ShaderPass(CopyShader);
    composer.addPass(copyPass);

    outlinePass = new OutlinePass(new Vector2(size.width, size.height), scene, camera)
    outlinePass.edgeStrength = 5;
    outlinePass.edgeThickness = 1;
    outlinePass.edgeGlow = 0.25;
    outlinePass.visibleEdgeColor.set('#EBEBEB');
    outlinePass.hiddenEdgeColor.set('#525252');
    outlinePass.renderToScreen = true;
    composer.addPass(outlinePass);

    fxaaShader = new ShaderPass(FXAAShader);
    composer.addPass(fxaaShader);
}

export function renderComposer(scene, camera) {
    composer.render(scene, camera);
}

export function resizeComposer(width, height) {
    composer.setSize(width, height, false);
}

export function resizeFxaa(width, height) {
    fxaaShader.uniforms['resolution'].value.set(1 / width, 1 / width);
} 

export function showOutlines(objects) {
    outlinePass.selectedObjects = objects;
}

export function hideOutlines() {
    outlinePass.selectedObjects = []
}